export class JurisdictionObligationOption { 
    name: string; 
    code: string;   
    //should get more properties later
}